export const SIDEBAR_LINKS = <const>[
  'dashboard',
  'calendar',
  'products',
  'sales',
  'reports',
  'toolset',
  'subscribers',
  'policies',
  'images',
  'my-account',
  'switch-centre'
]

export type SidebarNavListItemType = (typeof SIDEBAR_LINKS)[number]

export type SidebarNavListItem = {
  icon: string
  kind: string
  name: SidebarNavListItemType | string
  url?: string
  userId?: string
  alwaysPresent?: true
} & Partial<SidebarNavList>

export type SidebarNavList = { collection: SidebarNavListItem[] }

export const DEFAULT_SIDEBAR_PANEL = 'Sidebar'

export const SIDEBAR_ID = 'main-menu'

// TODO - Rename `ghost` with `unreleased`
export const SIDEBAR_GHOST_ITEM = 'ghost' // AKA future features
